import { computed, readonly, Ref, ref } from 'vue';

export const DEFAULT_LOADING_MESSAGE = 'Chargement...';

export interface Loader {
    isLoading: Readonly<Ref<boolean>>;
    loadingMessage: Readonly<Ref<string>>;
    startLoading(): void;
    stopLoading(): void;
    holdLoading(message: string): void;
    releaseLoading(): void;
}

// Requests (axios interceptor, V1 recording, screenshots) toggle this one.
const requestLoading = ref(false);
/*
 * eprocom-pwa#857: a flow that spans several requests holds the loader open with its own text, so the
 * student sees one loader from the upload to the next task — no flash between two requests.
 */
const heldMessage = ref<string | null>(null);

const isLoading = computed(() => requestLoading.value || heldMessage.value !== null);
const loadingMessage = computed(() => heldMessage.value ?? DEFAULT_LOADING_MESSAGE);

export default function useLoader(): Loader {
    const startLoading = () => {
        requestLoading.value = true;
    };

    const stopLoading = () => {
        requestLoading.value = false;
    };

    const holdLoading = (message: string) => {
        heldMessage.value = message;
    };

    const releaseLoading = () => {
        heldMessage.value = null;
    };

    return {
        isLoading: readonly(isLoading),
        loadingMessage: readonly(loadingMessage),
        startLoading,
        stopLoading,
        holdLoading,
        releaseLoading,
    };
}
